export default __webpack_public_path__ + "static/media/pint.81aadaf8.svg";